import {
    AI_TRANSFORM_STREAM_DONE,
    AI_TRANSFORM_STREAM_ERROR,
    RESET_AI_TRANSFORM,
    TRANSFORM_RICH_TEXT,
} from './aiTransform.type';

/**
 * Kicks off a manual RICH_TEXT transform. Streamed chunks arrive separately
 * via Socket.IO events `ai:chunk` / `ai:done` / `ai:error` filtered by the
 * conversationId returned in the success response.
 *
 * @param {string} sourceText  current value of the field (HTML or plain)
 * @param {string} instruction free-form clinician instruction
 */
export const transformRichText = (sourceText, instruction) => ({
    type: TRANSFORM_RICH_TEXT,
    payload: { sourceText, instruction },
});

export const resetAiTransform = () => ({
    type: RESET_AI_TRANSFORM,
});

export const markAiTransformStreamDone = () => ({
    type: AI_TRANSFORM_STREAM_DONE,
});

export const markAiTransformStreamError = () => ({
    type: AI_TRANSFORM_STREAM_ERROR,
});
